/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { OrderFragmentFragmentDoc } from './orderFragment.generated';
import { UserFragmentFragmentDoc } from './userFragment.generated';
import { PackagingHistoryFragmentFragmentDoc } from './packagingHistoryFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Base_Unit_Type_Enum =
  | 'BAG'
  | 'BAG_IN_BOX'
  | 'BOTTLE'
  | 'BOX'
  | 'BOX_SET'
  | 'BULK'
  | 'CAN'
  | 'CARTON'
  | 'CUP'
  | 'FLASK'
  | 'JAR'
  | 'KEG'
  /**   */
  | 'NET'
  | 'PACK'
  | 'PIECE'
  | 'SACHET'
  | 'SLICE'
  | 'SPRAY'
  | 'TIN'
  | 'TRAY'
  /**   */
  | 'TUB'
  | 'TUBE';

export type Billing_Type_Enum =
  /** billed per unit */
  | 'FIXED'
  /** billed per measured weight */
  | 'WEIGHT_DEPENDENT';

export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type Measurement_Unit_Enum =
  | 'CL'
  | 'G'
  | 'KG'
  | 'L'
  | 'ML'
  | 'T'
  /** Used to count units in logistical packages */
  | 'UNIT';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type Order_Status_Enum =
  | 'closed_but_contested_payment'
  | 'order_archived'
  | 'order_being_paid_by_buyer'
  | 'order_cancelled'
  | 'order_closed'
  | 'order_to_be_billed_by_supplier'
  | 'order_to_be_delivered_by_supplier'
  | 'order_to_be_paid_by_buyer'
  | 'order_to_be_prepared_by_supplier'
  | 'order_to_be_received_by_buyer'
  | 'order_to_be_validated_by_buyer'
  | 'order_to_be_validated_by_supplier';

export type Payment_Method_Enum =
  | 'BANK_TRANSFER'
  | 'NO_PAYMENT'
  | 'SDD_AUTO'
  | 'SDD_TRIGGERED';

export type Product_Label_Name_Enum =
  | 'AGRICULTURE_BIOLOGIQUE'
  | 'APPELLATION_ORIGINE_CONTROLEE'
  | 'APPELLATION_ORIGINE_PROTEGEE'
  | 'ECOCERT_ECODETERGENT'
  | 'GOUTEZ_ARDECHE'
  | 'HAUTE_VALEUR_ENVIRONNEMENTALE'
  | 'INDICATION_GEOGRAPHIQUE_PROTEGEE'
  | 'LABEL_ROUGE'
  | 'LE_PORC_FRANCAIS'
  | 'NATURE_ET_PROGRES'
  | 'ORIGINE_FRANCE_GARANTIE'
  | 'PRODUIT_ILE_DE_FRANCE'
  | 'SAVEURS_DE_NORMANDIE'
  | 'VALEURS_PARC_NATUREL_REGIONAL';

export type Staff_Role_Enum =
  | 'ADMIN';

export type Trade_Item_Unit_Descriptor_Enum =
  | 'CASE'
  | 'CRATE'
  | 'DISPLAY'
  | 'HALF_CASE'
  | 'PALLET'
  | 'SACK'
  /** Used when base units are sold individually */
  | 'UNIT';

export type OrderByReferenceIdQueryVariables = Exact<{
  orderReferenceId: string;
}>;


export type OrderByReferenceIdQuery = { order: Array<{ total_price_incl_tax: number | null, total_price_excl_tax: number | null, total_price_to_pay_excl_tax: number | null, total_price_to_pay_incl_tax: number | null, entered_status_at: string | null, suggestor_id: string | null, is_auto_validated: boolean, id: string, created_at: string, friendly_id: string, cancelled_by: Types.Business_Profile_Enum | null, updated_at: string, reference_id: string, delivery_date: string | null, payment_method: Types.Payment_Method_Enum | null, status: Types.Order_Status_Enum, sdd_payment_date: string | null, has_invoice_generation: boolean, suggestor: { id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, staff_user: { role: Types.Staff_Role_Enum } | null, default_avatar: { domain: string | null, path: string } | null } | null, items: Array<{ quantity: number, price: number, weight: number | null, orderId: string, packagingId: string, packaging: { id: string, company_id: string | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, gtin: string | null, trade_item_unit_descriptor: Types.Trade_Item_Unit_Descriptor_Enum, unit_quantity: number | null, net_content: number | null, sku: number, price: number, base_unit: { id: string, gtin: string | null, sku: number | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, unit_quantity: number | null, unit_type: Types.Base_Unit_Type_Enum | null, billing_type: Types.Billing_Type_Enum, unit_net_content: number | null, main_photo: { domain: string | null, path: string } | null, photos: Array<{ photo: { domain: string | null, path: string } | null }> } | null, product: { id: string, name: string, sku: number, sub_family: string, vat_rate: number | null, ingredients: string | null, allergens: string | null, calories: number | null, calories_kj: number | null, fat: number | null, saturated_fat: number | null, carbohydrate: number | null, sugars: number | null, sodium: number | null, protein: number | null, labels: Array<{ label: Types.Product_Label_Name_Enum }> } | null } }>, user: { id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null } | null, contract: { id: string, supplyingCompanyId: string, supplier_commission_rate: number | null, is_trusted_supplier: boolean, buyingCompanyId: string, minimum_order_value: number | null, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, discount: number, custom_price_list_id: string | null, channel_url: string | null, supplying_company: { invoice_prefix: string, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, photos: Array<{ photo: { path: string, domain: string | null } }> }, buying_company: { invoice_prefix: string, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, addresses: Array<{ formattedAddress: string }>, delivery_hours: Array<{ opening_hour: string, closing_hour: string, week_day: string }>, photos: Array<{ photo: { path: string, domain: string | null } }> }, custom_price_list: { name: string, custom_price_list_packagings: Array<{ packaging_sku: number, company_id: string, discount: number }> } | null } }>, previous_versions: Array<{ status: Types.Order_Status_Enum, id: string, total_price_excl_tax: number | null, items: Array<{ packagingId: string, quantity: number, price: number, weight: number | null, orderId: string }> }> };


export const OrderByReferenceIdDocument = /*#__PURE__*/ gql`
    query orderByReferenceId($orderReferenceId: uuid!) {
  order(where: {reference_id: {_eq: $orderReferenceId}}) {
    ...orderFragment
    total_price_incl_tax
    total_price_excl_tax
    total_price_to_pay_excl_tax
    total_price_to_pay_incl_tax
    entered_status_at
    suggestor_id
    is_auto_validated
    suggestor {
      ...userFragment
      staff_user {
        role
      }
    }
    items {
      packaging {
        ...packagingHistoryFragment
      }
      quantity
      price
      weight
      orderId
      packagingId
    }
  }
  previous_versions: order_history(
    where: {reference_id: {_eq: $orderReferenceId}}
    limit: 1
    offset: 1
    order_by: {updated_at: desc}
  ) {
    status
    id
    total_price_excl_tax
    items {
      packagingId
      quantity
      price
      weight
      orderId
    }
  }
}
    ${OrderFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${PackagingHistoryFragmentFragmentDoc}`;

/**
 * __useOrderByReferenceIdQuery__
 *
 * To run a query within a React component, call `useOrderByReferenceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderByReferenceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderByReferenceIdQuery({
 *   variables: {
 *      orderReferenceId: // value for 'orderReferenceId'
 *   },
 * });
 */
export function useOrderByReferenceIdQuery(baseOptions: Apollo.QueryHookOptions<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables> & ({ variables: OrderByReferenceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables>(OrderByReferenceIdDocument, options);
      }
export function useOrderByReferenceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables>(OrderByReferenceIdDocument, options);
        }
// @ts-ignore
export function useOrderByReferenceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables>;
export function useOrderByReferenceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrderByReferenceIdQuery | undefined, OrderByReferenceIdQueryVariables>;
export function useOrderByReferenceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables>(OrderByReferenceIdDocument, options);
        }
export type OrderByReferenceIdQueryHookResult = ReturnType<typeof useOrderByReferenceIdQuery>;
export type OrderByReferenceIdLazyQueryHookResult = ReturnType<typeof useOrderByReferenceIdLazyQuery>;
export type OrderByReferenceIdSuspenseQueryHookResult = ReturnType<typeof useOrderByReferenceIdSuspenseQuery>;
export type OrderByReferenceIdQueryResult = Apollo.QueryResult<OrderByReferenceIdQuery, OrderByReferenceIdQueryVariables>;